<template>
  <div class="user_point_shortage">
    <section class="text_center">
      <h2 class="header_underline">鑑定ポイント不足</h2>

      <p class="text_left">
        鑑定ポイントが不足している為、鑑定依頼メールの送信や添付画像の開封ができません。<br>
        恐れ入りますが、お手持ちのポイントを追加して頂いた後にご連絡されたい先生へご連絡下さいます様お願い致します。
      </p>
    </section>
    <point-purchase-list :info="info" />
  </div>
</template>

<script>
import PointPurchaseList from '@/components/point/PointPurchaseList'

export default {
  name: 'UserPointShortage',
  components: {
    PointPurchaseList
  },
  data () {
    return {
      info: this.$store.getters.siteInfo || null
    }
  },
  computed: {
    siteInfo () {
      return this.$store.getters.siteInfo
    }
  },
  watch: {
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
